<div
  [ngClass]="cssClass()"
  class="inline-flex text-sm font-bold uppercase">
  {{ status() | refundStatus | async }}
</div>
